/**
 * Supplier Metrics Screen
 *
 * Shows per-supplier summary metrics: recent sales/dilution volumes,
 * delinquent AR, gross/net AR balances, open credits, relationship
 * duration, invoice frequency, and collection activity. Data is
 * fetched from the Python backend on mount.
 */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getSupplierData } from "Redux/data/actions";
import DataTable from "Components/DataTable";
import ParameterSummary from "Components/ParameterSummary";

// -------------------------------------------------------------
// Column definitions — "n" placeholders in display text are
// resolved server-side to actual parameter values (e.g., 120 days).
// -------------------------------------------------------------
const headers = [
  { text: "Supplier", key: "Supplier", datatype: "string" },
  {
    text: "Sales Issued last n days",
    key: "Sales Issued last 120 days",
    datatype: "float",
  },
  {
    text: "Sales Due last n days",
    key: "Sales Due last 120 days",
    datatype: "float",
  },
  {
    text: "Dilution Issued last n days",
    key: "Dilution Issued last 120 days",
    datatype: "float",
  },
  {
    text: "Dilution Deemed last n days",
    key: "Dilution Deemed last 120 days",
    datatype: "float",
  },
  {
    text: "Delinquent Gross AR >n",
    key: "Delinquent Gross AR >60",
    datatype: "float",
  },
  {
    text: "Outstanding Gross AR Balance",
    key: "Outstanding Gross AR Balance",
    datatype: "float",
  },
  {
    text: "Open Credits On Account",
    key: "Open Credits On Account",
    datatype: "float",
  },
  {
    text: "Outstanding Net AR Balance",
    key: "Outstanding Net AR Balance",
    datatype: "float",
  },
  {
    text: "Days Trading With Buyer",
    key: "Days trading with Buyer",
    datatype: "int",
  },
  {
    text: "Invoices Last n Days",
    key: "Invoices Last 90 Days",
    datatype: "int",
  },
  {
    text: "Invoicing Months In Year",
    key: "Invoicing Months In Year",
    datatype: "int",
  },
  { text: "Collections In Year", key: "Collections In Year", datatype: "int" },
];

const Supplier = () => {
  const dispatch = useDispatch();
  const [, setViewing] = useState(false);
  const [showSummary] = useState(false);
  const { supplier } = useSelector((state) => state.data);
  const { hasMaster } = useSelector((state) => state.project);

  useEffect(() => {
      setViewing(true);
      dispatch(
        getSupplierData(() => {
          setViewing(false);
        })
      );
  }, [dispatch]);

  if (!hasMaster)
    return (
      <div className="notification is-warning is-light">
        No master frame has been built yet.
      </div>
    );
  return (
    <div>
      {showSummary && (
        <ParameterSummary
          parameterIDs={[
            "dilution_sales_horizon",
            "max_funding_tenor",
            "delinquency_cutoff",
            "invoice_window_size",
            "deemed_dilution_starting_point",
            "deemed_dilution_cutoff"
          ]}
        />
      )}

      {supplier && (
        <DataTable
          data={supplier.data}
          headers={headers}
          reference="Supplier"
        />
      )}
    </div>
  );
};

export default Supplier;